import axios from "axios";

export const sendMultiPartMedia = async ({ data = {}, url }) => {
  try {
    // Detailed logging of input data
    console.log("Input data for upload:", JSON.stringify(data, null, 2));

    // Validate data object before creating FormData
    if (!data || Object.keys(data).length === 0) {
      throw new Error("No data provided for upload");
    }

    const formData = new FormData();

    // Comprehensive debugging for each key-value pair
    Object.keys(data).forEach((key) => {
      const value = data[key];

      console.group(`Processing key: ${key}`);
      console.log("Value type:", typeof value);
      console.log("Value constructor:", value?.constructor?.name);

      // Handle array of files
      if (Array.isArray(value)) {
        console.log("Is array with length:", value.length);

        if (value.length === 0) {
          console.warn(`No files provided for key: ${key}`);
          console.groupEnd();
          return; // Skip empty arrays
        }

        value.forEach((item, index) => {
          console.log(`Array item ${index}:`, {
            type: typeof item,
            constructor: item?.constructor?.name,
            isFile: item instanceof File,
            isBlob: item instanceof Blob,
          });

          // Ensure the item is a File, Blob, or valid file-like object
          if (item instanceof File || item instanceof Blob) {
            formData.append(key, item, item.name || `file-${index}`);
            console.log(
              `Appended ${key} with file name: ${item.name || `file-${index}`}`
            );
          } else {
            console.warn(`Invalid file type for ${key} at index ${index}`);
          }
        });
      }
      // Handle single file or other data types
      else {
        console.log("Single value details:", {
          type: typeof value,
          constructor: value?.constructor?.name,
          isFile: value instanceof File,
          isBlob: value instanceof Blob,
        });

        if (value instanceof File || value instanceof Blob) {
          formData.append(key, value, value.name);
          console.log(`Appended ${key} with file name: ${value.name}`);
        } else {
          // For non-file data, append as is
          formData.append(key, value);
          console.log(`Appended ${key} with non-file value`);
        }
      }

      console.groupEnd();
    });

    // Debug FormData contents
    for (let [key, value] of formData.entries()) {
      console.log("FormData entry:", {
        key,
        value,
        type: value?.constructor?.name,
      });
    }

    // Validate that FormData is not empty
    if (formData.entries().next().done) {
      throw new Error("No valid files or data to upload");
    }

    const res = await axios.post(url, formData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return {
      status: "success",
      data: res.data,
    };
  } catch (e) {
    console.error("Error in multipart media upload:", e);

    // More detailed error handling
    return {
      status: "error",
      message: e.response?.data?.message || "Unexpected upload error",
      errors: e.response?.data?.errors || [e.message],
      fullError: e,
    };
  }
};

// Debugging helper function
export const debugFileUpload = (fileInput) => {
  if (!fileInput) {
    console.error("No file input provided");
    return;
  }

  console.log("File input details:", {
    files: fileInput.files,
    fileCount: fileInput.files.length,
  });

  // Detailed logging of each file
  Array.from(fileInput.files).forEach((file, index) => {
    console.log(`File ${index + 1} details:`, {
      name: file.name,
      type: file.type,
      size: file.size,
      lastModified: file.lastModified,
    });
  });
};
